// 🔒 AUTORIZACION-REMOTA-2026-11-03 — aviso al entrar (como el de stock bajo): «N solicitudes esperan tu autorización».
// Sale una vez por sesión del navegador y no tapa el aviso de turno (blocked).
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CLAVE = 'aviso_autorizaciones_visto';

export default function AvisoAutorizaciones({ allowed, count, listo, blocked }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [visto, setVisto] = useState(() => {
    try { return sessionStorage.getItem(CLAVE) === '1'; } catch { return false; }
  });
  const marcar = () => {
    setVisto(true);
    try { sessionStorage.setItem(CLAVE, '1'); } catch { /* sin almacenamiento: solo esta vez */ }
  };
  const enLaPantalla = location.pathname.startsWith('/autorizacion-remota');
  useEffect(() => { if (enLaPantalla && !visto) marcar(); }, [enLaPantalla, visto]);  // eslint-disable-line react-hooks/exhaustive-deps

  if (!listo || !allowed || count < 1 || blocked || visto || enLaPantalla) return null;
  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="aviso-autorizaciones">
      <div role="alertdialog" aria-labelledby="aviso-aut-titulo" className="bg-card border-2 border-primary/60 rounded-2xl shadow-2xl w-full max-w-md p-5 space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/15 flex items-center justify-center shrink-0"><ShieldCheck size={22} className="text-primary" /></div>
          <h2 id="aviso-aut-titulo" className="font-oswald font-bold text-lg">
            {count === 1 ? '1 solicitud espera tu autorización' : `${count} solicitudes esperan tu autorización`}
          </h2>
        </div>
        <p className="text-sm text-muted-foreground">Vencen a los 5 minutos de pedidas. Ábrelas para autorizar o rechazar.</p>
        <div className="grid grid-cols-2 gap-3">
          <Button variant="outline" className="min-h-[48px]" onClick={marcar}>Después</Button>
          <Button className="min-h-[48px]" onClick={() => { marcar(); navigate('/autorizacion-remota'); }} data-testid="aviso-autorizaciones-ver">Ver ahora</Button>
        </div>
      </div>
    </div>
  );
}
